import { setAuthHeader } from "./helpers";

import { api } from "./config";

// ==================== API-Calls ====================

export const initializeChatbot = async () => {
  try {
    await setAuthHeader();

    const response = await api.get("/init_bot");

    return response.data;
  } catch (error) {
    console.error("❌ Fehler bei init_bot:", error.response?.data || error);
  }
};

export const sendMessageToAI = async (message, sCurrentChatID, model) => {
  try {
    await setAuthHeader();

    const response = await api.post("/send_message", {
      bot_id: sCurrentChatID,
      message,
      model: model || "qwen2.5:32b",
    });

    return response.data;
  } catch (error) {
    console.error(
      "❌ Fehler bei sendMessageToAI:",
      error.response?.data || error
    );
  }
};

export const getChatbotHistory = async (sCurrentChatID) => {
  try {
    await setAuthHeader();

    const response = await api.get(`/get_chat/${sCurrentChatID}`);

    return response.data;
  } catch (error) {
    console.error(
      "❌ Fehler bei getChatbotHistory:",
      error.response?.data || error
    );
  }
};

export const getAllChats = async () => {
  try {
    await setAuthHeader();

    const response = await api.get("/get_all_chats");

    return response.data;
  } catch (error) {
    console.error("❌ Fehler bei getAllChats:", error.response?.data || error);
  }
};

export const deleteChat = async (sCurrentChatID) => {
  try {
    await setAuthHeader();

    const response = await api.delete(`/delete_chat/${sCurrentChatID}`);

    return response.data;
  } catch (error) {
    console.error("❌ Fehler bei deleteChat:", error.response?.data || error);
  }
};
